<template>
    <div>
        <UiCardListHeader
            :title="lang('congresses::ticket-orders.widgets.latest.title')"
            :action-href="route('congresses/ticket-orders.admin.index')"
            :action-label="lang('congresses::ticket-orders.actions.manage')"
        />

        <UiCardEmpty v-if="orders && orders.length === 0">
            {{ lang('congresses::ticket-orders.widgets.latest.no_orders') }}
        </UiCardEmpty>
        <UiCardList
            v-else-if="orders && orders.length > 0"
            as="transition-group"
            name="slide-fade"
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <TicketOrderPreview v-for="order in orders" :key="order.id" :order="order" />
        </UiCardList>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import TicketOrderPreview from '@src/Congresses/Pages/TicketOrders/TicketOrderPreview.vue';

interface TicketOrder {
    id: number;
    uuid: string;
    status: string;
    total_amount: number;
    created_at: string;
    user?: {
        id: number;
        name: string;
    };
    congress?: {
        id: number;
        title: string;
    };
}

interface WidgetData {
    orders?: TicketOrder[];
}

const props = defineProps<{ slug?: string; settings?: object; data?: WidgetData }>();

const orders: Ref<TicketOrder[]> = ref(props.data?.orders ?? []);

const load = () => {
    axios.get(route('congresses.admin.api.latest-ticket-orders')).then(({ data }) => {
        orders.value = data.orders;
    });
};

window.Echo.channel('admin').listen('.ticket-order.created', () => {
    load();
});
</script>
